import React from "react";
import { Modal } from "../../../../../components/common/Modal";
import { Button } from "../../../../../components/common/Button";
import { useSelector } from "react-redux";

import {
    selectDeleteUserPending,
    selectDeleteUserErrorMessage,
} from "../../../../../store/selectors";

type Props = {
    isOpen: boolean;
    user: any | null;
    onClose: () => void;
    onConfirm: () => void;
};

const DeleteUserModal: React.FC<Props> = ({
                                              isOpen,
                                              user,
                                              onClose,
                                              onConfirm,
                                          }) => {
    const pending = useSelector(selectDeleteUserPending);
    const error = useSelector(selectDeleteUserErrorMessage);

    return (
        <Modal isOpen={isOpen} onClose={pending ? undefined : onClose} title="Удалить пользователя?">
            <div className="text-sm text-slate-700">
                Вы уверены, что хотите удалить{" "}
                <span className="font-semibold">
                    {user?.name || "пользователя"}
                </span>
                ?
                <div className="mt-2 text-xs text-slate-500">
                    Действие необратимо.
                </div>
            </div>

            {error && (
                <div className="mt-3 text-xs text-red-500">
                    {error}
                </div>
            )}

            <div className="mt-5 flex justify-end gap-2">
                <Button
                    variant="secondary"
                    onClick={onClose}
                    text="Отмена"
                    disabled={pending}
                />

                <Button
                    variant="danger"
                    onClick={onConfirm}
                    text={pending ? "Удаление..." : "Удалить"}
                    disabled={pending}
                />
            </div>
        </Modal>
    );
};

export default DeleteUserModal;
